import dayjs from "dayjs";

const ROLE_LABELS = {
  ADMIN: "Admin",
  PROXY_ADMIN: "Proxy Admin",
  SUPERADMIN: "Super Admin",
  MANAGER: "Manager",
  EMPLOYEE: "Employee",
};

// The backend may send the actor's role as one string or as the JWT roles
// array; show the most privileged one.
export const formatActorRole = (role) => {
  const roles = Array.isArray(role) ? role : role ? [role] : [];
  const pick = ["SUPERADMIN", "ADMIN", "PROXY_ADMIN", "MANAGER", "EMPLOYEE"].find((r) =>
    roles.includes(r)
  );
  return pick ? ROLE_LABELS[pick] : "";
};

// Who acted on a record, and whether it was someone other than its owner.
// Records saved before the audit fields existed have no actor id, so they are
// never reported as on-behalf and screens keep their old display.
export const getActorInfo = ({ actorId, actorName, actorRole, ownerId, ownerName }) => {
  if (!actorId) {
    return { isOnBehalf: false, actorName: ownerName || "", roleLabel: "" };
  }
  const isOnBehalf = ownerId
    ? String(actorId) !== String(ownerId)
    : Boolean(actorName && ownerName && actorName !== ownerName);
  return {
    isOnBehalf,
    actorName: actorName || ownerName || "",
    roleLabel: formatActorRole(actorRole),
  };
};

// Same convention as the existing leave timeline: backend LocalDateTime values
// carry no zone and are UTC, so a bare value gets "Z" before formatting.
export const formatActorDate = (value) => {
  if (!value) return "";
  const text = String(value);
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(text);
  const parsed = dayjs(hasZone ? text : `${text}Z`);
  return parsed.isValid() ? parsed.format("DD MMM YYYY, hh:mm A") : "";
};
